// @flow
import update from 'immutability-helper';
import { ofType } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { deleteOrderApi, endpoints } from './api';
import { push } from 'react-router-redux';
import { of } from 'rxjs';
import { setNewAlert } from '../../../alert/duck';

import type { Observable } from 'rxjs';
import type { Order } from '../../../../entities';
import type { HTTPError } from '../../../../error';

export type UnconfirmedPaymentAction = {
  +type: string;
  +error?: HTTPError;
  +order?: Order;
  +orderId?: string;
};

export type UnconfirmedPaymentState = {
  +isDeletingOrder?: boolean;
  +deleteSuccess?: boolean;
  +deleteOrderError?: HTTPError;
};

const PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE = 'PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE';

const PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST = 'PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST';
const PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS = 'PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS';
const PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR = 'PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR';

export function deleteOrder(orderId: string): UnconfirmedPaymentAction {
  return {
    type: PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST,
    orderId,
  }
}

export function deleteOrderSuccessFn(order: Order): UnconfirmedPaymentAction {
  return {
    type: PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS,
    order,
  }
}

export function deleteOrderErrorFn(error: HTTPError): UnconfirmedPaymentAction {
  return {
    type: PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR,
    error,
  }
}

export function resetState(): UnconfirmedPaymentAction {
  return {
    type: PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE,
  }
}

export const actions = {
  PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE,
  PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST,
  PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS,
  PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR,
  deleteOrder,
  deleteOrderSuccessFn,
  deleteOrderErrorFn,
};

export const initialState: UnconfirmedPaymentState = {};

export default function reducer(state: UnconfirmedPaymentState = initialState,
                                action: UnconfirmedPaymentAction): UnconfirmedPaymentState {
  switch (action.type) {
    case PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST:
      return update(state, {
        isDeletingOrder: { $set: true },
        $unset: ['deleteOrderError', 'deleteSuccess'],
      });
    case PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_SUCCESS:
      return update(state, {
        deleteSuccess: { $set: true },
        $unset: ['isDeletingOrder'],
      });
    case PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_ERROR:
      return update(state, {
        deleteOrderError: { $set: action.error },
        $unset: ['isDeletingOrder'],
      });
    case PURCHASE_UNCONFIRMED_PAYMENT_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function purchaseUnconfirmedPaymentDeleteOrderEpic
(action$: Observable<UnconfirmedPaymentAction>): Observable<UnconfirmedPaymentAction> {
  return action$.pipe(
    ofType(PURCHASE_UNCONFIRMED_PAYMENT_DELETE_ORDER_REQUEST),
    mergeMap(({ orderId }) => deleteOrderApi(undefined, {
        route: endpoints.DELETE_ORDER.replace(':id', orderId)
      }).pipe(
      mergeMap(() => of(push('/orders/active'))),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(deleteOrderErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(deleteOrderErrorFn(e),
            setNewAlert('order', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(deleteOrderErrorFn(e));
      }))
    ));
}




// WEBPACK FOOTER //
// ./src/modules/order/Purchase/unconfirmed-payment/duck.js